import { render, staticRenderFns } from "./PharmacistsTableRow.vue?vue&type=template&id=56a6c0b4&"
import script from "./PharmacistsTableRow.vue?vue&type=script&lang=js&"
export * from "./PharmacistsTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports